import { Filter } from '@e3dc-react/shell/Elements/Filter'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import React from 'react'
import { SelectedFilter } from '../../models/shop-product-category.model'

interface ShopProductCategoryCurrentFilterProps {
  options: SelectedFilter[]
  filterName: string
  filterKey: string
  selectedValues: string[]
  onFilterChange: (key: string, value: string[]) => void
}

/*
 * This component renders an specific filter to shop product category
 */
const ShopProductCategoryCurrentFilter: React.FC<ShopProductCategoryCurrentFilterProps> = ({
  options,
  filterName,
  filterKey,
  selectedValues,
  onFilterChange,
}) => {
  const { t } = useCustomTranslation()
  return (
    <Filter
      options={options.map(option => ({
        label: option.label,
        value: option.value,
      }))}
      value={selectedValues}
      onChange={selectedValue => {
        onFilterChange(filterKey, selectedValue)
      }}
      label={t(filterName)}
    />
  )
}

export default ShopProductCategoryCurrentFilter
